module.exports = __webpack_public_path__ + "static/media/F4FF89B7-5615-4A22-B613-04E48FBB89BF.3e03a60c.JPG";